import { Box, useColorModeValue } from "@chakra-ui/react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

export default function UsageChart({ data }) {
  const axisColor = useColorModeValue("#1e1530", "#f8f6fb");      
  const gridColor = useColorModeValue("#E2E8F0", "#2D3748");     
  const tooltipBg = useColorModeValue("#FFFFFF", "#1b1845");     
  const tooltipText = useColorModeValue("#1e1530", "#f8f6fb");   
  const tooltipBorder = useColorModeValue("#CBD5E0", "#4A5568"); 

  return (
    <Box w="100%" h={{ base: "250px", md: "300px" }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid stroke={gridColor} strokeDasharray="3 3" />
          <XAxis
            dataKey="createdDate"
            tick={{ fontSize: 10, fill: axisColor }}
            tickMargin={8}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fill: axisColor }}
            tickMargin={8}
          />
          <Tooltip
            cursor={{ strokeWidth: 1 }}
            contentStyle={{
              backgroundColor: tooltipBg,
              borderColor: tooltipBorder,
              borderRadius: 8,
              boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
            }}
            labelStyle={{ color: tooltipText }}
            itemStyle={{ color: tooltipText }}
          />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#6C63FF"
            strokeWidth={2}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
